import {SET_INVOICES_LIST, SET_NAV_INVOICES_PARAMS, SET_INVOICES_STATUS_LIST} from "./constans";
import {invoicesAPI} from "../../API/API";


export const setInvoicesList = (payload) => {
    return {
        type: SET_INVOICES_LIST,
        payload
    }
}


export const setNavInvoicesParams = (payload) => {
    return {
        type: SET_NAV_INVOICES_PARAMS,
        payload
    }
}

export const setInvoicesStatusList = (payload) => {
    return {
        type: SET_INVOICES_STATUS_LIST,
        payload
    }
}


export const setInvoicesListFromCache = (review) => async (dispatch) => {
    await dispatch(setInvoicesList(review))
}

export const setInvoicesNavParamsFromCache = (navParams) => async (dispatch) => {
    await dispatch(setNavInvoicesParams(navParams))
}


export const getInvoices = (params) => async (dispatch) => {

    let invoicesPage = await invoicesAPI.getPages({...params, filter: JSON.stringify(params.filter)});

    if (invoicesPage.status) {
        dispatch(setNavInvoicesParams({pages: Object.keys(invoicesPage.data).length}))

        let invoicesIdArr = invoicesPage.data[params.page]

        let newDataReq = {
            ...params,
            filter: JSON.stringify({...params["filter"], object: invoicesIdArr})
        }

        let invoicesList = await invoicesAPI.getInvoiceList(newDataReq)

        if (invoicesList.status) {
            dispatch(setInvoicesList(invoicesList.data))
        }

    }
}


export const getStatusList = () => async (dispatch) => {
    let response = await invoicesAPI.getStatusList()
    if (response.status) {
        dispatch(setInvoicesStatusList(response.data))
    }
}
